import { render, staticRenderFns } from "./shippingAndDelivery.vue?vue&type=template&id=3d77da1f&scoped=true"
import script from "./shippingAndDelivery.vue?vue&type=script&lang=js"
export * from "./shippingAndDelivery.vue?vue&type=script&lang=js"
import style0 from "./shippingAndDelivery.vue?vue&type=style&index=0&id=3d77da1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77da1f",
  null
  
)

export default component.exports